import { useCallback, useRef, useState } from "react";

function jointMarkerSizeSignature(sizes) {
  if (!sizes) return "";
  return [
    Number(sizes.center || 0).toFixed(6),
    Number(sizes.endpoint || 0).toFixed(6),
    Number(sizes.glow || 0).toFixed(6),
  ].join("|");
}

export function useJointMarkerSizingState({ setStructureChangeTick }) {
  const [jointMarkerSizes, setJointMarkerSizes] = useState(null);
  const jointMarkerSizeSignatureRef = useRef("");
  const jointMarkerAutoResizeRebuildGuardRef = useRef({ key: "", count: 0 });
  const initialBuildDoneRef = useRef(false);
  const lastHandledStructureChangeTickRef = useRef(-1);

  const applyJointMarkerSizes = useCallback(
    (sizes, { requestRebuildOnChange = false, autoResizeKey = "" } = {}) => {
      if (!sizes) return;
      const sig = jointMarkerSizeSignature(sizes);
      if (!sig || sig === jointMarkerSizeSignatureRef.current) return;
      jointMarkerSizeSignatureRef.current = sig;
      setJointMarkerSizes(sizes);
      if (requestRebuildOnChange) {
        if (autoResizeKey) {
          const guard = jointMarkerAutoResizeRebuildGuardRef.current;
          if (guard.key !== autoResizeKey) {
            guard.key = autoResizeKey;
            guard.count = 0;
          }
          if (guard.count >= 1) return;
          guard.count += 1;
        }
        setStructureChangeTick((v) => v + 1);
      }
    },
    [setStructureChangeTick]
  );

  return {
    applyJointMarkerSizes,
    initialBuildDoneRef,
    jointMarkerAutoResizeRebuildGuardRef,
    jointMarkerSizes,
    lastHandledStructureChangeTickRef,
    setJointMarkerSizes,
  };
}
